import { Injectable } from '@angular/core';
import { PagesService } from 'src/app/pages/home/pages.service';
import { QubesUserManagementService } from 'src/app/pages/home/user-management-qubes/qubes-user-management.service';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'navigation',
    title: '',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [

      {
        id: 'dashboard-progress',
        title: 'Dashboard',
        name: 'Dashboard Progress',
        type: 'item',
        icon: 'feather icon-home',
        url: '/dashboard-progress',
        breadcrumbs: false,

      },
      {
        id: 'user-management-qubes',
        title: 'Settings / User Management',
        type: 'collapse',
        icon: 'feather icon-users',
        // hidden: false,
        children: [
          {
            id: 'qubes-user',
            title: 'Internal User',
            name: 'User',
            type: 'item',
            url: '/user-management-qubes/user',
            breadcrumbs: true,
            // hidden: false,
          },
          {
            id: 'moh-user',
            title: 'MOH User',
            type: 'item',
            url: '/user-management-qubes/user/moh-users',
            breadcrumbs: true,
            hidden: false

          },
          {
            id: 'qubes-user-group-master',
            title: 'Set Group Level',
            name: 'Set Group Level',
            type: 'item',
            url: '/user-management-qubes/user/user-group-master',
            breadcrumbs: true,
            // hidden: false,
          },
          {
            id: 'qubes-user-group',
            title: 'Create Group',
            name: 'Create Group',
            type: 'item',
            url: '/user-management-qubes/user/user-group',
            breadcrumbs: true,
            // hidden: false,
          },
          {
            id: 'qubes-user-role',
            title: 'User Role',
            name: 'User Role',
            type: 'item',
            url: '/user-management-qubes/user/user-role',
            breadcrumbs: true,
            // hidden: false,
          },
          {
            id: 'qubes-user-group-role-mapping',
            title: 'Group Role Mapping',
            name: 'Group Role Mapping',
            type: 'item',
            url: '/user-management-qubes/user/user-group-role-mapping',
            breadcrumbs: true,
            // hidden: false,
          },
          {
            id: 'qubes-user-group-menu-mapping',
            title: 'Group Menu Mapping',
            name: 'Group Menu Mapping',
            type: 'item',
            url: '/user-management-qubes/user/user-group-menu-mapping',
            breadcrumbs: true,
            // hidden: false,
          },
          // {
          //   id: 'app-usermanagement',
          //   title: 'MOHUsers',
          //   type: 'item',
          //   url: '/usermanagement/app-usermanagement',
          //   breadcrumbs: true,
          //   hidden : false

          // },
          {

            id: 'device-mapping',

            title: 'Device Mapping',

            name: 'Device Mapping',

            type: 'item',

            url: '/user-management-qubes/user/device-mapping',

            breadcrumbs: true,

            // hidden: false,

          },
        ]
      },

      {
        id: 'master',
        title: 'Setting / Master / Asset Mgmt',
        name: 'Master',
        type: 'collapse',
        icon: 'feather icon-book',
        url: '/loading',
        breadcrumbs: true,
        children: [


          {
            id: 'master',
            title: 'Supplier and Manufacturer',
            name: 'AMD',
            type: 'item',
            // icon: 'feather icon-book',
            url: '/master/amd',
            breadcrumbs: true,
            // hidden: true,
          },


          {
            id: 'master',
            title: 'Clinic Details',
            name: 'Clinic',
            type: 'item',
            // icon: 'feather icon-heart',
            url: '/master/clinic',
            breadcrumbs: true,
            // hidden: true,
          },
          {
            id: 'master',
            title: 'Loan and Test Equipment',
            name: 'Relationship',
            type: 'item',
            // icon: 'feather icon-minimize',
            url: '/master/LoanAndTest',
            breadcrumbs: true,
            // hidden: true,
          },
          {
            id: 'master',
            title: 'Holiday Mapping',
            name: 'Holiday',
            type: 'item',
            // icon: 'feather icon-minimize',
            url: '/master/holidaychange',
            breadcrumbs: true,
            // hidden: true,
          },


        ]
      },

      {
        id: 'amd-report',
        title: 'AMD',
        name: 'AMD Report',
        type: 'group',
        icon: 'feather icon-briefcase',
        url: '/amd-report',
        breadcrumbs: true,
        children: [
          {
            id: 'amd-report',
            title: 'Equipment Management',
            name: 'Equipment Management',
            icon: 'fa fa-suitcase',
            type: 'collapse',
            breadcrumbs: true,


            children: [
              {
                id: 'add-new-equipment',
                title: 'BE Registration',
                type: 'item',
                url: '/amd-report/add-new-equipment',
                breadcrumbs: false,

              },
              // {
              //   id: 'amd-report',
              //   title: 'Modify Equipment',
              //   type: 'item',
              //   url: '/amd-report/Modify-Equipment',
              //   breadcrumbs: true,
              // },
              {
                id: 'amd-report',
                title: 'End of Warranty Process',
                type: 'item',
                url: '/amd-report/end-process',
                breadcrumbs: true,
              },

              // {
              //   id: 'amd-report',
              //   title: 'BE Conditional Status Change',
              //   type: 'item',
              //   url: '/amd-report/status-change-list',
              //   breadcrumbs: false,
              // },
              // {
              //   id: 'amd-report',
              //   title: 'BE Relocation',
              //   type: 'item',
              //   url: '/amd-report/location-change-list',
              //   breadcrumbs: false,
              // },


              // {
              //   id: 'amd-report',
              //   title: 'DeActivate/ReActivate',
              //   type: 'item',
              //   url: '/layout/static',
              // },
              // {
              //   id: 'amd-report',
              //   title: 'Removal Of Equipment',
              //   type: 'item',
              //   url: '/layout/static',
              // },
              // {
              //   id: 'amd-report',
              //   title: 'Add Clinic',
              //   type: 'item',
              //   url: '/amd-report/add-clinic',
              //   breadcrumbs: false,

              // },
            ],
          },
          {
            id: 'master',
            title: 'InternalVAR-Process',
            name: 'Master',
            type: 'collapse',
            icon: 'feather icon-layers',
            url: '/loading',
            breadcrumbs: true,
            children: [
              {
                id: 'master',
                title: 'Internal VAR-1',
                name: 'Internalvs1',
                type: 'item',
                url: '/master/Internalvs1',
                breadcrumbs: true,


              },
            ]
          },
          {
            id: 'amd-report',
            title: 'VAR-Process',
            name: 'AMD Report',
            type: 'collapse',
            icon: 'feather icon-layers',
            url: '/amd-report',
            breadcrumbs: true,
            children: [
              {
                id: 'amd-report',
                title: 'VAR-1 -  Clinic',
                name: 'additionlistnew',
                type: 'item',
                url: '/master/vs1clinic',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-1',
                name: 'AMD Report',
                type: 'item',
                url: '/master/varone',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-2',
                name: 'Additional Equipment',
                type: 'item',
                url: '/master/additionallist',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-3',
                name: 'Omissionlist',
                type: 'item',
                url: '/master/omissionlist',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-4',
                name: 'Additional Equipment',
                type: 'item',
                url: '/master/varfour',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-5',
                name: 'Var5NewComponent',
                type: 'item',
                url: '/master/varfive',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'amd-report',
                title: 'VAR-6',
                name: 'Omissionlist',
                type: 'item',
                url: '/master/varsix',
                breadcrumbs: true,
                // hidden: true,
              },


            ]
          },


          //main asset report for the project//
          {
            id: 'amd-report',
            title: 'Asset Report',
            name: 'AMD Report',
            type: 'collapse',
            icon: 'feather icon-server',
            url: '/amd-report',
            breadcrumbs: false,
            // hidden: true,
            children: [
              // {
              //   id: 'amd-report-year',
              //   title: 'Asset Report Period Wise',
              //   name: 'AMD Report Period Wise',
              //   type: 'item',
              //   url: '/amd-report/amd-report-year',
              //   breadcrumbs: false,
              //   // hidden: true,
              // },
              // {
              //   id: 'amd-report',
              //   title: 'Asset Details',
              //   name: 'AMD Report',
              //   type: 'item',
              //   // icon: 'feather icon-server',
              //   url: '/amd-report',
              //   breadcrumbs: false,
              // },
              // {
              //   id: 'amd-report',
              //   title: 'Asset-Expenses Report',
              //   name: 'AMD Report',
              //   type: 'item',
              //   // icon: 'feather icon-server',
              //   url: '/amd-report/asset-new',
              //   breadcrumbs: false,
              // },
              {
                id: 'amd-report',
                title: 'BE Number Info',
                name: 'BeInfo',
                type: 'item',
                url: '/amd-report/BE-info',
                breadcrumbs: false,
              },
              {
                id: 'amd-report',
                // title: 'BE List',
                title: 'BE List',
                name: 'BE List',
                type: 'item',
                url: '/amd-report/Be-listtemp',
                breadcrumbs: false,
              },
               {id: 'amd-report',
               title: 'Asset List',
               name: 'BeInfo',
               type: 'item',
               url: '/amd-report/asseList',
               breadcrumbs: false,
              },
              {id: 'amd-report',
              title: 'Asset-Report',
              name: 'BeInfo',
              type: 'item',
              url: '/amd-report/assetReportLatest',
              breadcrumbs: false,
             },
             {id: 'amd-report',
             title: 'Asset Ageing-Report',
             name: 'BeInfo',
             type: 'item',
             url: '/amd-report/ageingReport',
             breadcrumbs: false,
            },
            {id: 'amd-report',
             title: 'Asset Summary-Report',
             name: 'BeInfo',
             type: 'item',
             url: '/amd-report/summaryReport',
             breadcrumbs: false,
            },
            {id: 'amd-report',
            title: 'Open Work-Order',
            name: 'BeInfo',
            type: 'item',
            url: '/amd-report/openWorkOrder',
            breadcrumbs: false,
           },
            {id: 'amd-report',
            title: 'KPI Penalty Report',
            name: 'BeInfo',
            type: 'item',
            url: '/amd-report/kpiReport',
            breadcrumbs: false,
           },
            ]
          },
        ]
      },
      // user management

      {
        id: 'amd-report',
        title: 'TSD',
        name: 'TSD',
        type: 'group',
        icon: 'feather icon-file',
        url: '/tsd',
        breadcrumbs: true,
        children: [
          {
            id: 'amd-report',
            title: 'Master-TSD',
            name: 'Master-TSD',
            icon: 'feather icon-book',
            type: 'collapse',
            breadcrumbs: true,
            children: [
              {
                id: 'tsd',
                title: 'Problem Reported',
                name: 'Problem Reported',
                type: 'item',
                url: '/tsd/m_problemReported',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Problem Identified',
                name: 'Problem Identified',
                type: 'item',
                url: '/tsd/m_problemIdentified',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Causal Factor',
                name: 'Causal Factor',
                type: 'item',
                url: '/tsd/m_casualFactor',
                breadcrumbs: true,
                // hidden: true,
              },
            ],
          },
            {
              id: 'amd-report',
              title: 'Process Hierarchy',
              name: 'Master-TSD',
              icon: 'feather icon-link',
              type: 'collapse',
              breadcrumbs: true,
              children: [
              // new
              {
                id: 'tsd',
                title: 'CEO',
                name: 'CEO',
                type: 'item',
                url: '/tsd/ceo',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'GM',
                name: 'GM',
                type: 'item',
                url: '/tsd/gm',
                breadcrumbs: true,
                // hidden: true,
              },

              {
                id: 'tsd',
                title: 'AGM',
                name: 'AGM',
                type: 'item',
                url: '/tsd/u_AGM',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'TTFT Manager',
                name: 'TTFT Manager',
                type: 'item',
                url: '/tsd/u_ttftManager',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Super Specialists',
                name: 'Super Specialists',
                type: 'item',
                url: '/tsd/u_superSpecialist',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'State Manager',
                name: 'State Manager',
                type: 'item',
                url: '/tsd/u_stateManager',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Admin Executive',
                name: 'Admin Executive',
                type: 'item',
                url: '/tsd/u_adminExecutive',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Admin Assistant',
                name: 'Admin Assistant',
                type: 'item',
                url: '/tsd/u_adminAssistant',
                breadcrumbs: true,
                // hidden: true,
              },{
                id: 'tsd',
                title: 'Data Entry Clerk',
                name: 'Data Entry Clerk',
                type: 'item',
                url: '/tsd/u_dataEntryClerk',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Specialists',
                name: 'Specialists',
                type: 'item',
                url: '/tsd/u_Specialists',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Circle-In-Charge',
                name: 'Circle-In-Charge ',
                type: 'item',
                url: '/tsd/u_CircleIncharge',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Technician',
                name: 'Technician',
                type: 'item',
                url: '/tsd/u_Techinicians',
                breadcrumbs: true,
                // hidden: true,
              },
              // {
              //   id: 'tsd',
              //   title: 'Repair Penalty',
              //   name: 'Repair Penalty',
              //   type: 'item',
              //   url: '/tsd/repairpenaltykpi',
              //   breadcrumbs: true,
              // },
              // {
              //   id: 'tsd',
              //   title: 'Response Penalty',
              //   name: 'Response Penalty',
              //   type: 'item',
              //   url: '/tsd/responsepenaltykpi',
              //   breadcrumbs: true,
              // },
              // {
              //   id: 'tsd',
              //   title: 'PPM Penalty',
              //   name: 'PPM Penalty',
              //   type: 'item',
              //   url: '/tsd/ppmpenaltykpi',
              //   breadcrumbs: true,
              // },
              // {
              //   id: 'tsd',
              //   title: 'Uptime Penalty',
              //   name: 'Uptime Penalty',
              //   type: 'item',
              //   url: '/tsd/uptimepenaltykpi',
              //   breadcrumbs: true,
              // },
              {
                id: 'tsd',
                title: 'Process-TSD-Hierarchy',
                name: 'Process Hierarchy',
                type: 'item',
                // url: '#',
                url: '/tsd/processhierarchy',
                breadcrumbs: false,
                // hidden: true,
              },
              ],
          },
          {
            id: 'master',
            title: 'Breakdown Maintenance',
            name: 'Master',
            type: 'collapse',
            icon: 'fa fa-address-card',
            url: '/loading',
            breadcrumbs: true,
            children: [
              {
                id: 'tsd',
                title: 'Work Request',
                name: 'Work Request',
                type: 'item',
                // url: '#',
                url: '/tsd/workRequest',
                breadcrumbs: false,
                // hidden: true,
              },

              {
                id: 'tsd',
                title: 'Work Request MGMT',
                name: 'Work Request',
                type: 'item',
                // url: '#',
                url: '/tsd/workOrder',
                breadcrumbs: false,
                // hidden: true,
              },
            ]
          },


          {
            id: 'master',
            title: 'PPM Schedule Maintenance',
            name: 'Master',
            type: 'collapse',
            icon: 'feather icon-repeat',
            url: '/loading',
            breadcrumbs: true,
            children: [
              {
                id: 'tsd',
                title: 'Plan Management',
                name: 'Work Request',
                type: 'item',
                // url: '#',
                url: '/tsd/scheduleMaintenanceProcess',
                breadcrumbs: false,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Work Order Generation',
                name: 'Work Request',
                type: 'item',
                // url: '#',
                url: '/tsd/ppmSchedule',
                breadcrumbs: false,
                // hidden: true,
              },
              {
                id: 'tsd',
                title: 'Work Request MGMT',
                name: 'Work Request',
                type: 'item',
                // url: '#',
                url: '/tsd/woTechnician',
                breadcrumbs: false,
                // hidden: true,
              },
            ]
          },
          // {
          //   id: 'tsd',
          //   title: 'Stores Location',
          //   name: 'Work Request',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/storesLocation',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {

          //   id: 'tsd',
          //   title: 'Stock Master',
          //   name: 'Work Request',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/stockMaster',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
    ]

  },
  // {
  //   id: 'amd-report',
  //   title: 'TSD-Reports',
  //   name: 'TSD',
  //   type: 'group',
  //   icon: 'feather icon-file',
  //   url: '/tsd',
  //   breadcrumbs: true,
  //   children: [
  //     {
  //       id: 'tsd',
  //       title: 'Provision Schedule',
  //       name: 'Problem Reported',
  //       type: 'item',
  //       url: '/tsd/provisionSchedule',
  //       breadcrumbs: true,
  //       // hidden: true,
  //     },
  //     {
  //       id: 'tsd',
  //       title: 'Final Schedule',
  //       name: 'Problem Identified',
  //       type: 'item',
  //       url: '/tsd/finalSchedule',
  //       breadcrumbs: true,
  //       // hidden: true,
  //     },
  //   ]
  // },
          // {
          //   id: 'tsd',
          //   title: 'TSD',
          //   name: 'TSD',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'SM View',
          //   name: 'SM View',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/sm-view',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'WR Report',
          //   name: 'WR Report',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/wr-report',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'Work Order',
          //   name: 'Work Order',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/work-order',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'Final Schedule',
          //   name: 'WR Report',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/finalschedule',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'Provisional Schedule',
          //   name: 'Work Order',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/provisionalschedule',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'tsd',
          //   title: 'Maintenance Service',
          //   name: 'Work Order',
          //   type: 'item',
          //   // url: '#',
          //   url: '/tsd/maintenanceservice',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },

      
      {
        id: 'amd-report',
        title: 'MMD',
        name: 'AMD Report',
        type: 'group',
        icon: 'feather icon-file-minus',
        url: '/amd-report',
        breadcrumbs: true,
        // children: [
        //   {
        //     id: 'amd-report',
        //     title: 'Asset Report',
        //     name: 'AMD Report',
        //     type: 'item',
        //     url: '/amd-report',
        //     breadcrumbs: false,
        //     // hidden: true,
        //   },
        // ]
      },



      {
        id: 'controls',
        title: 'Controls',
        type: 'group',
        icon: 'feather icon-lock',
        url: '/settings',
        breadcrumbs: true,
        children: [
          {
            id: 'master',
            title: 'Contractual',
            name: 'Contractual',
            type: 'item',
            icon: 'feather icon-slash',
            url: '/master/contractual',
            breadcrumbs: true,
            // hidden: true,
          },

          {
            id: 'master',
            title: 'Configurable',
            name: 'Location',
            type: 'collapse',
            icon: 'feather icon-lock',
            url: '/master/location',
            breadcrumbs: true,
            // hidden: true,
            children: [

              {
                id: 'master',
                title: 'Location',
                name: 'Location',
                type: 'item',
                url: '/master/location',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'master',
                title: 'AMD',
                name: 'Config',
                type: 'item',
                url: '/master/ConfigurableAmd',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'master',
                title: 'KPI & Penalty Alerts',
                name: 'Config',
                type: 'item',
                url: '/master/ConfigurableTsd',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'master',
                title: 'Penalty Values',
                name: 'Config',
               type: 'item',
                url: '/master/ConfigurableKPITsd',
                breadcrumbs: true,
                // hidden: true,
              },
              {
                id: 'master',
                title: 'Public and School Holiday List',
                name: 'Holiday',
                type: 'item',
                url: '/master/holiday',
                breadcrumbs: true,
              },
              {
                id: 'amd-report',
                title: 'Modify Equipment',
                type: 'item',
                url: '/amd-report/Modify-Equipment',
                breadcrumbs: true,
              },
            ]
          }
        ]
      },
     
      {
        id: 'settings',
        title: 'Settings',
        name: 'Settings',
        type: 'group',
        icon: 'feather icon-settings',
        url: '/settings',
        breadcrumbs: false,
        children: [


          // {
          //   id: 'full-calendar',
          //   title: 'Calendar',
          //   name: 'full-calendar',
          //   type: 'item',
          //   icon: 'feather icon-calendar',
          //   url: '/settings/full-calendar',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },
          // {
          //   id: 'settings',
          //   title: 'Theme Customizer',
          //   name: 'Customize',
          //   type: 'item',
          //   icon: 'feather icon-sun',
          //   url: '/settings/customize',
          //   breadcrumbs: false,
          //   // hidden: true,
          // },

        ]
      },
    ]
  }
];

@Injectable({ providedIn: 'root' })
export class NavigationItem {
  constructor(private userManagementService: QubesUserManagementService, private pagesService: PagesService) { }
  public get() {
    this.userManagementService.getAllUserGroupMenuMappingByGroupId(this.pagesService.getMenuMappingPriorityGroupId()).subscribe((datas) => {

      NavigationItems.forEach((navigation => {
        navigation.children.forEach((mainMenu: any) => {
          mainMenu.hidden = ((mainMenu?.children == undefined) || (mainMenu?.children?.length == 0)) ? true : false;

          if (mainMenu.type == 'group') { // for groups

            if (mainMenu.children != undefined && mainMenu.children.length > 0) {
              mainMenu?.children?.forEach((mainMenuFromGroup) => {

                if (mainMenuFromGroup.type == 'item') { // item inside groups..
                  // console.log("Mainmenu when item : ",mainMenuFromGroup)
                  mainMenuFromGroup.hidden = (datas.find(data => data.menuName == mainMenuFromGroup.title)? false : true);

                } else { // collapse inside groups
                  mainMenuFromGroup.children?.forEach((subMenu) => {
                    if (subMenu.type == 'item' && datas.find(data => data.menuName == subMenu.title)) {
                      subMenu.hidden = false
                      mainMenu.hidden = false
                      mainMenuFromGroup.hidden = false;
                      // mainMenu.hidden = false;
                    } else {
                      subMenu.hidden = true
                      // mainMenu.hidden = false
                      // mainMenuFromGroup.hidden = true;
                    }
                  })

                  mainMenuFromGroup.hidden = mainMenuFromGroup?.children?.some(obj => obj.hidden == false) ? false : true;


                }


              })
              mainMenu.hidden = mainMenu?.children?.some(obj => obj.hidden == false) ? false : true;

            }
          }
          else if (mainMenu.children != undefined) { // for only collapse

            mainMenu?.children?.forEach((subMenu) => {
              if (subMenu.type == 'item' && datas.find(data => data.menuName == subMenu.title)) {
                subMenu.hidden = false
                mainMenu.hidden = false
              } else {
                subMenu.hidden = true
                // mainMenu.hidden = true
              }
            })

            mainMenu.hidden = mainMenu?.children?.some(obj => obj.hidden == false) ? false : true;

          } else if (mainMenu.type == 'item') { // for only items 
            mainMenu.hidden = (datas.find(data => data.menuName == mainMenu.title)) ? false : true;
          }

        })
      }))
    })
    // console.log("Check the Navigations : ", NavigationItems)
    return NavigationItems;
  }
}
